var path = '/templates/projects.campaigns/views/directives/campaign_segment_graph.html';
var html = "<div class=row><div class=col-md-6><div id=chart3><highchart config=sessionChartConfig></highchart></div></div><div class=col-md-6><div id=chart3><highchart config=conversionChartConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_segment_graph.html
// module id = 1384
// module chunks = 0